import "../App.css";
import "leaflet/dist/leaflet.css";
import { useEffect, useMemo, useState } from "react";
import api, { requestWithRetry } from "../services/api";
import Footer from "../components/Footer";
import {
  MapContainer,
  TileLayer,
  CircleMarker,
  useMap,
  useMapEvents,
} from "react-leaflet";
import olhoAberto from "../assets/olho-aberto.png";
import olhoFechado from "../assets/olho-fechado.png";

function ClickMap({ onSelect }) {
  useMapEvents({
    click(e) {
      onSelect(e.latlng);
    },
  });

  return null;
}

function MapUpdater({ center, zoom }) {
  const map = useMap();

  useEffect(() => {
    if (center && Array.isArray(center)) {
      map.setView(center, zoom || 16);
    }
  }, [center, zoom, map]);

  return null;
}

function ModalMapa({ onClose, onConfirm }) {
  const [pontoSelecionado, setPontoSelecionado] = useState(null);
  const [enderecoPreview, setEnderecoPreview] = useState("");
  const [carregandoEndereco, setCarregandoEndereco] = useState(false);

  const [enderecoBusca, setEnderecoBusca] = useState("");
  const [resultadosBusca, setResultadosBusca] = useState([]);
  const [buscandoLocais, setBuscandoLocais] = useState(false);
  const [obtendoLocalizacaoAtual, setObtendoLocalizacaoAtual] = useState(false);

  const [mapCenter, setMapCenter] = useState([-25.5307, -49.2037]);
  const [mapZoom, setMapZoom] = useState(13);

  const [locaisFavoritos, setLocaisFavoritos] = useState([]);
  const [carregandoFavoritos, setCarregandoFavoritos] = useState(false);
  const [mostrarFavoritos, setMostrarFavoritos] = useState(false);
  const [salvandoFavorito, setSalvandoFavorito] = useState(false);

 

  useEffect(() => {
    carregarLocaisFavoritos();
  }, []);

  function detectarDispositivo() {
    const ua = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(ua)) return "android";

    if (
      /iPad|iPhone|iPod/.test(ua) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
    ) {
      return "ios";
    }

    return "outro";
  }

  async function carregarLocaisFavoritos() {
    try {
      setCarregandoFavoritos(true);
      const response = await api.get("/admin/locais-favoritos");
      setLocaisFavoritos(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Erro ao carregar locais favoritos:", error);
      setLocaisFavoritos([]);
    } finally {
      setCarregandoFavoritos(false);
    }
  }

  function abrirNoMapaDoCelular() {
    const endereco = enderecoBusca.trim();
    const tipo = detectarDispositivo();

    let url = "";

    if (pontoSelecionado?.lat && pontoSelecionado?.lng) {
      if (tipo === "ios") {
        url = `http://maps.apple.com/?ll=${pontoSelecionado.lat},${pontoSelecionado.lng}`;
      } else {
        url = `https://www.google.com/maps?q=${pontoSelecionado.lat},${pontoSelecionado.lng}`;
      }
    } else if (endereco) {
      if (tipo === "ios") {
        url = `http://maps.apple.com/?q=${encodeURIComponent(endereco)}`;
      } else {
        url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(endereco)}`;
      }
    } else {
      alert("Digite um endereço ou selecione um local antes de abrir o mapa do celular");
      return;
    }

    window.open(url, "_blank");
  }

  async function buscarEndereco(lat, lng) {
    try {
      setCarregandoEndereco(true);

      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`,
      );
      const data = await response.json();

      const endereco =
        data.display_name || `Lat ${lat.toFixed(6)}, Lng ${lng.toFixed(6)}`;

      setEnderecoPreview(endereco);
      setEnderecoBusca(endereco);
    } catch (error) {
      console.error("Erro ao buscar endereço:", error);

      const enderecoFallback = `Lat ${lat.toFixed(6)}, Lng ${lng.toFixed(6)}`;
      setEnderecoPreview(enderecoFallback);
      setEnderecoBusca(enderecoFallback);
    } finally {
      setCarregandoEndereco(false);
    }
  }

  function extrairNumeroEndereco(texto) {
  if (!texto) return "";
  const match = texto.match(/\b\d{1,6}[A-Za-z]?\b/);
  return match ? match[0].toLowerCase() : "";
}

function normalizarTexto(texto) {
  return String(texto || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

function extrairRuaEndereco(texto) {
  if (!texto) return "";

  const semCep = texto.replace(/\b\d{5}-?\d{3}\b/g, "");
  const partes = semCep.split(",");

  if (partes.length > 0) {
    const primeiraParte = partes[0];
    const semNumero = primeiraParte.replace(/\b\d{1,6}[A-Za-z]?\b/g, "");
    return normalizarTexto(semNumero);
  }

  return normalizarTexto(semCep.replace(/\b\d{1,6}[A-Za-z]?\b/g, ""));
}

function pontuarResultadoBusca(resultado, enderecoDigitado) {
  const numeroBuscado = extrairNumeroEndereco(enderecoDigitado);
  const ruaBuscada = extrairRuaEndereco(enderecoDigitado);

  const displayName = normalizarTexto(resultado.display_name || "");
  const address = resultado.address || {};

  const houseNumber = normalizarTexto(
    address.house_number ||
      address.houseNumber ||
      address.housenumber ||
      "",
  );

  const road = normalizarTexto(
    address.road ||
      address.pedestrian ||
      address.footway ||
      address.residential ||
      address.cycleway ||
      "",
  );

  let score = 0;

  if (numeroBuscado) {
    if (houseNumber === numeroBuscado) {
      score += 100;
    } else if (displayName.includes(numeroBuscado)) {
      score += 50;
    }
  }

  if (ruaBuscada) {
    if (road && (road.includes(ruaBuscada) || ruaBuscada.includes(road))) {
      score += 40;
    } else if (displayName.includes(ruaBuscada)) {
      score += 20;
    }
  }

  return score;
}

  async function pesquisarEndereco() {
  if (!enderecoBusca.trim()) {
    alert("Digite um endereço para pesquisar");
    return;
  }

  try {
    setBuscandoLocais(true);
    setResultadosBusca([]);

    const query = enderecoBusca.trim();

    const response = await fetch(
      `https://nominatim.openstreetmap.org/search?format=jsonv2&addressdetails=1&countrycodes=br&q=${encodeURIComponent(
        query,
      )}&limit=10`,
    );

    const data = await response.json();
    const lista = Array.isArray(data) ? data : [];

    const resultadosOrdenados = [...lista].sort((a, b) => {
      const scoreA = pontuarResultadoBusca(a, query);
      const scoreB = pontuarResultadoBusca(b, query);

      if (scoreA !== scoreB) {
        return scoreB - scoreA;
      }

      return 0;
    });

    setResultadosBusca(resultadosOrdenados);

    if (resultadosOrdenados.length === 0) {
      alert("Nenhum endereço encontrado");
    }
  } catch (error) {
    console.error("Erro ao pesquisar endereço:", error);
    alert("Erro ao pesquisar endereço");
  } finally {
    setBuscandoLocais(false);
  }
}

  function selecionarResultado(resultado) {
    const lat = Number(resultado.lat);
    const lon = Number(resultado.lon);

    const ponto = { lat, lng: lon };

    setPontoSelecionado(ponto);
    setEnderecoPreview(resultado.display_name || "");
    setEnderecoBusca(resultado.display_name || "");
    setMapCenter([lat, lon]);
    setMapZoom(17);
    setResultadosBusca([]);
  }

  async function handleSelecionar(latlng) {
    setPontoSelecionado(latlng);
    setMapCenter([latlng.lat, latlng.lng]);
    setMapZoom(17);
    await buscarEndereco(latlng.lat, latlng.lng);
  }

  async function usarMinhaLocalizacaoAtual() {
    if (!navigator.geolocation) {
      alert("Este dispositivo não oferece suporte à localização");
      return;
    }

    try {
      setObtendoLocalizacaoAtual(true);
      setResultadosBusca([]);

      const posicao = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          enableHighAccuracy: true,
          timeout: 15000,
          maximumAge: 10000,
        });
      });

      const lat = posicao.coords.latitude;
      const lng = posicao.coords.longitude;

      const ponto = { lat, lng };

      setPontoSelecionado(ponto);
      setMapCenter([lat, lng]);
      setMapZoom(18);

      await buscarEndereco(lat, lng);
    } catch (error) {
      console.error("Erro ao obter localização atual:", error);
      alert(
        "Não foi possível obter sua localização atual. Verifique a permissão de localização no navegador.",
      );
    } finally {
      setObtendoLocalizacaoAtual(false);
    }
  }

  async function salvarLocalAtualComoFavorito() {
    if (!pontoSelecionado) {
      alert("Selecione um local no mapa antes de salvar nos favoritos");
      return;
    }

    const nomeFavorito = window.prompt("Digite um nome para este local favorito:");

    if (!nomeFavorito || !nomeFavorito.trim()) {
      return;
    }

    try {
      setSalvandoFavorito(true);

      await api.post("/admin/locais-favoritos", {
        nome: nomeFavorito.trim(),
        endereco:
          enderecoPreview ||
          `Lat ${pontoSelecionado.lat}, Lng ${pontoSelecionado.lng}`,
        latitude: pontoSelecionado.lat,
        longitude: pontoSelecionado.lng,
      });

      await carregarLocaisFavoritos();
      setMostrarFavoritos(true);
      alert("Local favorito salvo com sucesso");
    } catch (error) {
      const mensagem =
        error.response?.data?.message || "Erro ao salvar local favorito";
      alert(mensagem);
    } finally {
      setSalvandoFavorito(false);
    }
  }

  function selecionarFavorito(local) {
    const lat = Number(local.latitude);
    const lng = Number(local.longitude);

    setPontoSelecionado({ lat, lng });
    setEnderecoPreview(local.endereco || "");
    setEnderecoBusca(local.endereco || "");
    setMapCenter([lat, lng]);
    setMapZoom(17);
    setResultadosBusca([]);
  }

  async function excluirFavorito(id) {
    const confirmar = window.confirm("Deseja remover este local favorito?");
    if (!confirmar) return;

    try {
      await api.delete(`/admin/locais-favoritos/${id}`);
      await carregarLocaisFavoritos();
    } catch (error) {
      const mensagem =
        error.response?.data?.message || "Erro ao remover local favorito";
      alert(mensagem);
    }
  }

  function confirmarLocal() {
    if (!pontoSelecionado) {
      alert("Selecione um ponto no mapa");
      return;
    }

    onConfirm({
      nome: `Local ${Date.now()}`,
      endereco:
        enderecoPreview ||
        `Lat ${pontoSelecionado.lat}, Lng ${pontoSelecionado.lng}`,
      latitude: pontoSelecionado.lat,
      longitude: pontoSelecionado.lng,
    });
  }

  const textoBotaoMapaCelular =
    detectarDispositivo() === "ios"
      ? "Abrir Apple Maps"
      : "Abrir Google Maps";

  return (
    <div className="scanner-overlay">
      <div className="map-modal">
        <h3>Selecionar local no mapa</h3>

        <div className="actions" style={{ marginTop: 16, marginBottom: 12 }}>
          <input
            className="input"
            placeholder="Digite um endereço"
            value={enderecoBusca}
            onChange={(e) => setEnderecoBusca(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                pesquisarEndereco();
              }
            }}
          />

          <button
            type="button"
            className="action-btn"
            onClick={pesquisarEndereco}
            disabled={buscandoLocais}
          >
            {buscandoLocais ? "Pesquisando..." : "Pesquisar endereço"}
          </button>
        </div>

        <div
          style={{
            display: "flex",
            gap: 8,
            flexWrap: "wrap",
            marginBottom: 12,
          }}
        >
          <button
            type="button"
            className="action-btn secondary"
            onClick={usarMinhaLocalizacaoAtual}
            disabled={obtendoLocalizacaoAtual}
            style={{
              padding: "10px 14px",
              fontSize: 14,
              minWidth: "unset",
              flex: "0 0 auto",
            }}
          >
            {obtendoLocalizacaoAtual
              ? "Obtendo localização..."
              : "Usar minha localização"}
          </button>

          <button
            type="button"
            className="action-btn secondary"
            onClick={abrirNoMapaDoCelular}
            style={{
              padding: "10px 14px",
              fontSize: 14,
              minWidth: "unset",
              flex: "0 0 auto",
            }}
          >
            {textoBotaoMapaCelular}
          </button>

          <button
            type="button"
            className="action-btn secondary"
            onClick={() => setMostrarFavoritos((prev) => !prev)}
            style={{
              padding: "10px 14px",
              fontSize: 14,
              minWidth: "unset",
              flex: "0 0 auto",
            }}
          >
            {mostrarFavoritos ? "Ocultar favoritos" : "Locais salvos"}
          </button>
        </div>

        {mostrarFavoritos && (
          <div
            style={{
              marginBottom: 14,
              padding: 12,
              borderRadius: 14,
              background: "rgba(255,255,255,0.05)",
              border: "1px solid rgba(255,255,255,0.08)",
              maxHeight: 220,
              overflowY: "auto",
            }}
          >
            <div
              style={{
                color: "#fff",
                fontWeight: 700,
                marginBottom: 10,
              }}
            >
              Locais favoritos
            </div>

            {carregandoFavoritos ? (
              <p style={{ color: "#ccc", margin: 0 }}>Carregando favoritos...</p>
            ) : locaisFavoritos.length === 0 ? (
              <p style={{ color: "#ccc", margin: 0 }}>
                Nenhum local favorito salvo ainda.
              </p>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                {locaisFavoritos.map((local) => (
                  <div
                    key={local._id}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: 8,
                      alignItems: "flex-start",
                      background: "rgba(255,255,255,0.04)",
                      borderRadius: 12,
                      padding: 10,
                    }}
                  >
                    <div
                      style={{ flex: 1, cursor: "pointer" }}
                      onClick={() => selecionarFavorito(local)}
                    >
                      <div style={{ color: "#fff", fontWeight: 700 }}>
                        {local.nome}
                      </div>
                      <div
                        style={{
                          color: "#c9d7e3",
                          fontSize: 13,
                          marginTop: 4,
                          lineHeight: 1.4,
                        }}
                      >
                        {local.endereco}
                      </div>
                    </div>

                    <button
                      type="button"
                      className="action-btn secondary"
                      onClick={() => excluirFavorito(local._id)}
                      style={{
                        padding: "8px 10px",
                        fontSize: 12,
                        minWidth: "unset",
                        flex: "0 0 auto",
                      }}
                    >
                      Excluir
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {resultadosBusca.length > 0 && (
          <div
            style={{
              marginBottom: 14,
              maxHeight: 180,
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              gap: 8,
            }}
          >
            {resultadosBusca.map((resultado, index) => (
              <button
                key={`${resultado.place_id}-${index}`}
                type="button"
                className="action-btn secondary"
                style={{
                  textAlign: "left",
                  whiteSpace: "normal",
                  lineHeight: 1.4,
                }}
                onClick={() => selecionarResultado(resultado)}
              >
                <div>
                  <div style={{ fontWeight: 700 }}>
                    Busca: {enderecoBusca.trim()}
                  </div>
                  <div style={{ opacity: 0.82, marginTop: 4 }}>
                    Resultado: {resultado.display_name}
                  </div>
                </div>
              </button>
            ))}
          </div>
        )}

        <div className="map-wrapper">
          <MapContainer
            center={mapCenter}
            zoom={mapZoom}
            style={{ height: "100%", width: "100%" }}
          >
            <MapUpdater center={mapCenter} zoom={mapZoom} />

            <TileLayer
              attribution="&copy; OpenStreetMap"
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />

            <ClickMap onSelect={handleSelecionar} />

            {pontoSelecionado && (
              <CircleMarker
                center={[pontoSelecionado.lat, pontoSelecionado.lng]}
                radius={10}
                pathOptions={{
                  color: "#00c2cb",
                  fillColor: "#00c2cb",
                  fillOpacity: 0.8,
                }}
              />
            )}
          </MapContainer>
        </div>

        <div className="map-info">
          {carregandoEndereco ? (
            <p>Buscando endereço...</p>
          ) : enderecoPreview ? (
            <p>
              <strong>Endereço:</strong> {enderecoPreview}
            </p>
          ) : (
            <p>Digite um endereço, use sua localização ou toque no mapa para marcar o local.</p>
          )}
        </div>

        <div
          style={{
            display: "flex",
            gap: 8,
            flexWrap: "wrap",
            marginBottom: 12,
          }}
        >
          <button
            type="button"
            className="action-btn secondary"
            onClick={salvarLocalAtualComoFavorito}
            disabled={salvandoFavorito}
            style={{
              padding: "10px 14px",
              fontSize: 14,
              minWidth: "unset",
              flex: "0 0 auto",
            }}
          >
            {salvandoFavorito ? "Salvando local..." : "Salvar este local"}
          </button>
        </div>

        <div className="map-actions">
          <button className="action-btn" onClick={confirmarLocal}>
            Confirmar local
          </button>
          <button className="action-btn secondary" onClick={onClose}>
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}

function SectionCard({
  title,
  subtitle,
  icon,
  open,
  onToggle,
  children,
  rightContent,
  hidden = false,
}) {
  if (hidden) return null;

  return (
    <div
      className={`admin-menu-card ${open ? "admin-menu-card-open" : ""}`}
      onClick={() => {
        if (!open) onToggle();
      }}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (!open && (e.key === "Enter" || e.key === " ")) {
          e.preventDefault();
          onToggle();
        }
      }}
    >
      <div className="admin-menu-card-header">
        <div className="admin-menu-card-left">
          <div className="admin-menu-icon">{icon}</div>

          <div className="admin-menu-texts">
            <h3>{title}</h3>
            {subtitle ? <p>{subtitle}</p> : null}
          </div>
        </div>

        <div
          className="admin-menu-card-right"
          onClick={(e) => e.stopPropagation()}
        >
          {rightContent}

          <button
            type="button"
            className="admin-menu-toggle"
            onClick={onToggle}
          >
            {open ? "Ocultar" : "Abrir"}
          </button>
        </div>
      </div>

      {open && <div className="admin-menu-card-content">{children}</div>}
    </div>
  );
}

function AdminDashboard({ setUser }) {
  const [users, setUsers] = useState([]);

  const [novoNome, setNovoNome] = useState("");
  const [novoDataNascimento, setNovoDataNascimento] = useState("");
  const [novoSexo, setNovoSexo] = useState("");
  const [novoIdade, setNovoIdade] = useState("");
  const [novoCelular, setNovoCelular] = useState("");
  const [novoEmail, setNovoEmail] = useState("");
  const [novoSaldo, setNovoSaldo] = useState("");
  const [novaSenha, setNovaSenha] = useState("");
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [tipoOperacaoQRCode, setTipoOperacaoQRCode] = useState("credito");

  const [loading, setLoading] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState("");
  const [erroUsuarios, setErroUsuarios] = useState("");
  const [erroRankingsAdmin, setErroRankingsAdmin] = useState("");

  const [usuarioEmEdicao, setUsuarioEmEdicao] = useState(null);
  const [editNome, setEditNome] = useState("");
  const [editDataNascimento, setEditDataNascimento] = useState("");
  const [editSexo, setEditSexo] = useState("");
  const [editIdade, setEditIdade] = useState("");
  const [editCelular, setEditCelular] = useState("");
  const [editEmail, setEditEmail] = useState("");
  const [editSenha, setEditSenha] = useState("");
  const [mostrarSenhaEdicao, setMostrarSenhaEdicao] = useState(false);

  const [qrcodes, setQrcodes] = useState([]);
  const [carregandoQRCodes, setCarregandoQRCodes] = useState(true);
  const [salvandoQRCode, setSalvandoQRCode] = useState(false);

  const [qrNome, setQrNome] = useState("");
  const [qrValor, setQrValor] = useState("");
  const [qrDataInicio, setQrDataInicio] = useState("");
  const [qrHoraInicio, setQrHoraInicio] = useState("");
  const [qrDataFim, setQrDataFim] = useState("");
  const [qrHoraFim, setQrHoraFim] = useState("");
  const [qrRaio, setQrRaio] = useState("100");
  const [qrLocais, setQrLocais] = useState([]);
  const [mostrarMapa, setMostrarMapa] = useState(false);

  const [arquivoImportacao, setArquivoImportacao] = useState(null);
  const [importandoUsuarios, setImportandoUsuarios] = useState(false);
  const [resultadoImportacao, setResultadoImportacao] = useState(null);

  const [mostrarUsuarios, setMostrarUsuarios] = useState(false);
  const [mostrarCriacaoManual, setMostrarCriacaoManual] = useState(false);
  const [mostrarImportacao, setMostrarImportacao] = useState(false);
  const [mostrarLayout, setMostrarLayout] = useState(false);
  const [mostrarResetAdmin, setMostrarResetAdmin] = useState(false);
  const [mostrarRelatorios, setMostrarRelatorios] = useState(false);
  const [mostrarGerarQR, setMostrarGerarQR] = useState(false);
  const [mostrarQRCodesGerados, setMostrarQRCodesGerados] = useState(false);
  const [mostrarMensagensAdmin, setMostrarMensagensAdmin] = useState(false);
  const [mostrarRankingNext, setMostrarRankingNext] = useState(false);
  const [mostrarRankingGE, setMostrarRankingGE] = useState(false);

  const [buscaUsuario, setBuscaUsuario] = useState("");
  const [buscaMenuAdmin, setBuscaMenuAdmin] = useState("");

  const [novoIsLider, setNovoIsLider] = useState(false);
  const [editIsLider, setEditIsLider] = useState(false);
  const [mostrarRankingLideres, setMostrarRankingLideres] = useState(false);
  const [rankingLideres, setRankingLideres] = useState([]);

  const [processandoResetSaldo, setProcessandoResetSaldo] = useState(false);
  const [processandoResetExtrato, setProcessandoResetExtrato] = useState(false);
  const [processandoResetGeral, setProcessandoResetGeral] = useState(false);

  const [layoutCloud1Arquivo, setLayoutCloud1Arquivo] = useState(null);
  const [layoutCloud2Arquivo, setLayoutCloud2Arquivo] = useState(null);
  const [layoutCloud3Arquivo, setLayoutCloud3Arquivo] = useState(null);

  const [layoutNome, setLayoutNome] = useState("");
  const [layoutCorPrimaria, setLayoutCorPrimaria] = useState("#00c2cb");
  const [layoutCorSecundaria, setLayoutCorSecundaria] = useState("#0f2a3a");
  const [layoutCorDestaque, setLayoutCorDestaque] = useState("#6ecbff");
  const [layoutFonte, setLayoutFonte] = useState("Inter");
  const [layoutMostrarNuvens, setLayoutMostrarNuvens] = useState(true);
  const [layoutLogoArquivo, setLayoutLogoArquivo] = useState(null);
  const [layoutCoinLogoArquivo, setLayoutCoinLogoArquivo] = useState(null);
  const [layoutLoginBackgroundArquivo, setLayoutLoginBackgroundArquivo] =
    useState(null);
  const [layoutCoinsPorNivel, setLayoutCoinsPorNivel] = useState("500");
  const [layoutNomesNiveis, setLayoutNomesNiveis] = useState([
    "Nível 1",
    "Pro",
    "Elite",
    "Legend",
    "Master",
    "Supreme",
    "Omega",
  ]);
  const [mostrarEditarNiveis, setMostrarEditarNiveis] = useState(false);
  const [salvandoLayout, setSalvandoLayout] = useState(false);

  const [mensagensAdmin, setMensagensAdmin] = useState([]);
  const [tituloMensagem, setTituloMensagem] = useState("");
  const [conteudoMensagem, setConteudoMensagem] = useState("");
  const [gruposDestinoMensagem, setGruposDestinoMensagem] = useState(["todos"]);
  const [enviandoMensagem, setEnviandoMensagem] = useState(false);
  const [exigeConfirmacaoMensagem, setExigeConfirmacaoMensagem] = useState(false);
  const [mensagensExpandidas, setMensagensExpandidas] = useState({});

  const [rankingNext, setRankingNext] = useState([]);
  const [rankingGE, setRankingGE] = useState([]);
  const [carregandoRankingsAdmin, setCarregandoRankingsAdmin] =
    useState(true);

  const fontesPermitidas = [
    "Inter",
    "Poppins",
    "Roboto",
    "Montserrat",
    "Nunito",
    "Open Sans",
    "Lato",
    "Oswald",
    "Raleway",
    "Merriweather",
    "Playfair Display",
    "Bebas Neue",
    "Ubuntu",
    "Fira Sans",
    "Quicksand",
  ];

  useEffect(() => {
    carregarUsuarios();
    carregarQRCodes();
    carregarLayout();
    carregarMensagensAdmin();
    carregarRankingsAdmin();
  }, []);

  function aplicarMascaraData(valor) {
    const numeros = valor.replace(/\D/g, "").slice(0, 8);

    if (numeros.length <= 2) return numeros;
    if (numeros.length <= 4)
      return `${numeros.slice(0, 2)}/${numeros.slice(2)}`;

    return `${numeros.slice(0, 2)}/${numeros.slice(2, 4)}/${numeros.slice(4)}`;
  }

  function aplicarMascaraHora(valor) {
    const numeros = valor.replace(/\D/g, "").slice(0, 4);

    if (numeros.length <= 2) return numeros;

    return `${numeros.slice(0, 2)}:${numeros.slice(2)}`;
  }

  function converterIsoParaDataBR(valor) {
    if (!valor) return "";

    if (/^\d{2}\/\d{2}\/\d{4}$/.test(valor)) {
      return valor;
    }

    if (/^\d{4}-\d{2}-\d{2}$/.test(valor)) {
      const [ano, mes, dia] = valor.split("-");
      return `${dia}/${mes}/${ano}`;
    }

    const data = new Date(valor);

    if (Number.isNaN(data.getTime())) return "";

    const dia = String(data.getDate()).padStart(2, "0");
    const mes = String(data.getMonth() + 1).padStart(2, "0");
    const ano = String(data.getFullYear());

    return `${dia}/${mes}/${ano}`;
  }

  function validarDataBR(valor) {
    if (!/^\d{2}\/\d{2}\/\d{4}$/.test(valor)) return false;

    const [dia, mes, ano] = valor.split("/").map(Number);
    const data = new Date(ano, mes - 1, dia);

    return (
      data.getFullYear() === ano &&
      data.getMonth() === mes - 1 &&
      data.getDate() === dia
    );
  }

  function validarHora(valor) {
    if (!/^\d{2}:\d{2}$/.test(valor)) return false;

    const [hora, minuto] = valor.split(":").map(Number);

    return hora >= 0 && hora <= 23 && minuto >= 0 && minuto <= 59;
  }

  function converterDataBRParaISO(valor) {
    if (!valor) return "";

    if (/^\d{4}-\d{2}-\d{2}$/.test(valor)) {
      return valor;
    }

    if (!validarDataBR(valor)) return "";

    const [dia, mes, ano] = valor.split("/");
    return `${ano}-${mes}-${dia}`;
  }

  function montarDataHoraISO(dataBR, hora) {
    if (!validarDataBR(dataBR) || !validarHora(hora)) return "";

    const [dia, mes, ano] = dataBR.split("/").map(Number);
    const [horas, minutos] = hora.split(":").map(Number);

    return new Date(ano, mes - 1, dia, horas, minutos, 0, 0).toISOString();
  }

  function calcularIdade(dataNascimento) {
    if (!dataNascimento) return "";

    const dataBR = converterIsoParaDataBR(dataNascimento);

    if (!validarDataBR(dataBR)) return "";

    const [dia, mes, ano] = dataBR.split("/").map(Number);
    const hoje = new Date();
    const nascimento = new Date(ano, mes - 1, dia);

    let idade = hoje.getFullYear() - nascimento.getFullYear();
    const diferencaMes = hoje.getMonth() - nascimento.getMonth();

    if (
      diferencaMes < 0 ||
      (diferencaMes === 0 && hoje.getDate() < nascimento.getDate())
    ) {
      idade--;
    }

    return idade >= 0 ? String(idade) : "";
  }

  function formatarDataExibicao(valor) {
    return converterIsoParaDataBR(valor) || "-";
  }

  function atualizarNomeNivel(index, valor) {
    setLayoutNomesNiveis((prev) => {
      const proximo = [...prev];
      proximo[index] = valor;
      return proximo;
    });
  }

  function formatarNomeRanking(nome) {
    if (!nome) return "";
    const partes = nome.trim().split(/\s+/).filter(Boolean);
    if (partes.length <= 1) return partes[0] || "";
    return `${partes[0]} ${partes[partes.length - 1]}`;
  }

  function getNivelPorSaldo(saldo) {
    const saldoAtual = Number(saldo || 0);

    const niveis =
      Array.isArray(layoutNomesNiveis) && layoutNomesNiveis.length === 7
        ? layoutNomesNiveis
        : [
            "Nível 1",
            "Pro",
            "Elite",
            "Legend",
            "Master",
            "Supreme",
            "Omega",
          ];

    const divisor =
      Number(layoutCoinsPorNivel) > 0 ? Number(layoutCoinsPorNivel) : 500;
    const indice = Math.floor(saldoAtual / divisor);

    return niveis[indice] || `Nível ${indice + 1}`;
  }

  function getRankingInfo(index) {
    if (index === 0) {
      return {
        medalha: "🥇",
        classe: "ranking-card ranking-primeiro",
        posicao: "1º",
      };
    }

    if (index === 1) {
      return {
        medalha: "🥈",
        classe: "ranking-card ranking-segundo",
        posicao: "2º",
      };
    }

    if (index === 2) {
      return {
        medalha: "🥉",
        classe: "ranking-card ranking-terceiro",
        posicao: "3º",
      };
    }

    return {
      medalha: "🏅",
      classe: "ranking-card",
      posicao: `${index + 1}º`,
    };
  }

  function toggleMensagemExpandida(id) {
  setMensagensExpandidas((prev) => ({
    ...prev,
    [id]: !prev[id],
  }));
}

  function alternarGrupoDestinoMensagem(grupo) {
  setGruposDestinoMensagem((prev) => {
    if (grupo === "todos") {
      return ["todos"];
    }

    let novosGrupos = prev.filter((item) => item !== "todos");

    if (novosGrupos.includes(grupo)) {
      novosGrupos = novosGrupos.filter((item) => item !== grupo);
    } else {
      novosGrupos.push(grupo);
    }

    return novosGrupos.length > 0 ? novosGrupos : ["todos"];
  });
}
  
  function formatarGrupoMensagem(grupo) {
    if (Array.isArray(grupo)) {
      if (grupo.includes("todos")) return "Enviada para todos";
  
      const nomes = grupo.map((item) => {
        if (item === "next") return "Next";
        if (item === "ge") return "GE";
        if (item === "lideres") return "Líderes";
        return item;
      });
  
      return `Enviada para: ${nomes.join(", ")}`;
    }
  
    if (grupo === "todos") return "Enviada para todos";
    if (grupo === "next") return "Enviada para o grupo Next";
    if (grupo === "ge") return "Enviada para o grupo GE";
    if (grupo === "lideres") return "Enviada para o grupo Líderes";
    return "Grupo não identificado";
  }

  function escaparCSV(valor) {
    const texto = String(valor ?? "");
    return `"${texto.replace(/"/g, '""')}"`;
  }

  function baixarArquivoCSV(nomeArquivo, linhas) {
    const conteudo = linhas.map((linha) => linha.join(";")).join("\n");
    const blob = new Blob([conteudo], {
      type: "text/csv;charset=utf-8;",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = nomeArquivo;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  async function baixarRelatorioUsuariosCSV() {
    try {
      const response = await api.get("/admin/reports/users");
      const dados = response.data || {};

      const linhas = [
        ["campo", "valor"],
        ["total_usuarios", dados.total_usuarios ?? 0],
        ["total_usuarios_ativos", dados.total_usuarios_ativos ?? 0],
        ["total_lideres", dados.total_lideres ?? 0],
        ["total_next", dados.total_next ?? 0],
        ["total_ge", dados.total_ge ?? 0],
        ["total_fora_faixa", dados.total_fora_faixa ?? 0],
        [""],
        [
          "nome",
          "email",
          "celular",
          "sexo",
          "idade",
          "data_nascimento",
          "saldo",
          "lider",
          "ativo",
          "perfil",
          "data_criacao",
        ],
      ];

      (dados.usuarios || []).forEach((usuario) => {
        linhas.push([
          escaparCSV(usuario.nome || ""),
          escaparCSV(usuario.email || ""),
          escaparCSV(usuario.celular || ""),
          escaparCSV(usuario.sexo || ""),
          Number(usuario.idade || 0),
          escaparCSV(usuario.data_nascimento || ""),
          Number(usuario.saldo || 0),
          usuario.is_lider ? "Sim" : "Não",
          usuario.ativo ? "Sim" : "Não",
          escaparCSV(usuario.role || ""),
          escaparCSV(usuario.createdAt || ""),
        ]);
      });

      baixarArquivoCSV("relatorio_usuarios.csv", linhas);
    } catch (error) {
      const mensagem =
        error.response?.data?.message || "Erro ao gerar relatório de usuários";
      alert(mensagem);
    }
  }

  async function baixarRelatorioRankingsCSV() {
    try {
      const response = await api.get("/admin/reports/rankings");
      const dados = response.data || {};

      const linhas = [
        [
          "grupo",
          "posicao",
          "nome",
          "saldo",
          "idade",
          "data_nascimento",
          "lider",
        ],
      ];

      const adicionarGrupo = (grupoNome, lista = []) => {
        lista.forEach((item, index) => {
          linhas.push([
            escaparCSV(grupoNome),
            index + 1,
            escaparCSV(item.nome || ""),
            Number(item.saldo || 0),
            Number(item.idade || 0),
            escaparCSV(item.data_nascimento || ""),
            item.is_lider ? "Sim" : "Não",
          ]);
        });
      };

      adicionarGrupo("Next", dados.next || []);
      adicionarGrupo("GE", dados.ge || []);
      adicionarGrupo("Lideres", dados.lideres || []);

      baixarArquivoCSV("relatorio_rankings.csv", linhas);
    } catch (error) {
      const mensagem =
        error.response?.data?.message || "Erro ao gerar relatório de rankings";
      alert(mensagem);
    }
  }

  async function baixarRelatorioExtratoCSV() {
    try {
      const response = await api.get("/admin/reports/extrato");
      const dados = response.data || {};

      const linhas = [
        ["usuario", "email", "tipo", "valor", "descricao", "origem", "data"],
      ];

      (dados.transacoes || []).forEach((item) => {
        linhas.push([
          escaparCSV(item.user_id?.nome || ""),
          escaparCSV(item.user_id?.email || ""),
          escaparCSV(item.tipo || ""),
          Number(item.valor || 0),
          escaparCSV(item.descricao || ""),
          escaparCSV(item.origem || ""),
          escaparCSV(item.createdAt || ""),
        ]);
      });

      baixarArquivoCSV("relatorio_extrato.csv", linhas);
    } catch (error) {
      const mensagem =
        error.response?.data?.message || "Erro ao gerar relatório de extrato";
      alert(mensagem);
    }
  }

  async function baixarRelatorioQRCodesCSV() {
    try {
      const response = await api.get("/admin/reports/qrcodes");
      const dados = response.data || {};

      const linhas = [
        [
          "nome",
          "codigo",
          "valor",
          "ativo",
          "inicio",
          "fim",
          "total_resgates",
          "quantidade_locais",
          "data_criacao",
        ],
      ];

      (dados.campanhas || []).forEach((item) => {
        linhas.push([
          escaparCSV(item.nome || ""),
          escaparCSV(item.codigo || ""),
          Number(item.valor || 0),
          item.ativo ? "Sim" : "Não",
          escaparCSV(item.inicio || ""),
          escaparCSV(item.fim || ""),
          Number(item.total_resgates || 0),
          Number(item.locais_permitidos?.length || 0),
          escaparCSV(item.createdAt || ""),
        ]);
      });

      baixarArquivoCSV("relatorio_qrcodes.csv", linhas);
    } catch (error) {
      const mensagem =
        error.response?.data?.message || "Erro ao gerar relatório de QR Codes";
      alert(mensagem);
    }
  }

  async function carregarUsuarios() {
    try {
      setErro("");
      setErroUsuarios("");
      setLoading(true);
  
      const response = await requestWithRetry(
        () => api.get("/admin/users"),
        {
          retries: 2,
          delayMs: 1500,
        },
      );
  
      setUsers(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Erro ao carregar usuários:", error);
  
      const mensagem =
        error.response?.data?.message ||
        "Não foi possível carregar os usuários agora.";
  
      setErro(mensagem);
      setErroUsuarios(mensagem);
    } finally {
      setLoading(false);
    }
  }

  async function carregarRankingsAdmin() {
    try {
      setCarregandoRankingsAdmin(true);
      setErroRankingsAdmin("");
  
      const response = await requestWithRetry(
        () => api.get("/user/admin-rankings"),
        {
          retries: 2,
          delayMs: 1500,
        },
      );
  
      setRankingNext(response.data?.next?.ranking || []);
      setRankingGE(response.data?.ge?.ranking || []);
      setRankingLideres(response.data?.lideres?.ranking || []);
    } catch (error) {
      console.error("Erro ao carregar rankings do admin:", error);
      setErroRankingsAdmin("Não foi possível carregar os rankings agora.");
    } finally {
      setCarregandoRankingsAdmin(false);
    }
  }

  function baixarModeloUsuarios() {
    const conteudo =
      "nome;data_nascimento;email;celular;sexo;senha;saldo_inicial;Lider\n";

    const blob = new Blob([conteudo], {
      type: "text/csv;charset=utf-8;",
    });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "modelo_usuarios.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(url);
  }

  async function carregarLayout() {
    try {
      const response = await api.get("/layout");
      const config = response.data;

      setLayoutNome(config.app_name || "");
      setLayoutCorPrimaria(config.primary_color || "#00c2cb");
      setLayoutCorSecundaria(config.secondary_color || "#0f2a3a");
      setLayoutCorDestaque(config.accent_color || "#6ecbff");
      setLayoutFonte(config.font_family || "Inter");
      setLayoutMostrarNuvens(!!config.show_clouds);
      setLayoutCoinsPorNivel(String(config.coins_per_level || 500));
      setLayoutNomesNiveis(
        Array.isArray(config.level_names) && config.level_names.length === 7
          ? config.level_names
          : [
              "Nível 1",
              "Pro",
              "Elite",
              "Legend",
              "Master",
              "Supreme",
              "Omega",
            ],
      );
    } catch (error) {
      console.error("Erro ao carregar layout:", error);
    }
  }

  async function removerImagemLogin() {
    const confirmar = window.confirm(
      "Deseja realmente remover a imagem de fundo do login?",
    );

    if (!confirmar) return;

    try {
      await api.delete("/layout/login-background");
      setLayoutLoginBackgroundArquivo(null);
      await carregarLayout();
      alert("Imagem de fundo do login removida com sucesso");
    } catch (error) {
      const mensagem =
        error.response?.data?.message ||
        "Erro ao remover imagem de fundo do login";
      alert(mensagem);
    }
  }

  async function removerNuvemLogin(indice) {
    const confirmar = window.confirm(
      `Deseja realmente remover a nuvem ${indice} do login?`,
    );

    if (!confirmar) return;

    try {
      await api.delete(`/layout/login-cloud/${indice}`);

      if (indice === 1) setLayoutCloud1Arquivo(null);
      if (indice === 2) setLayoutCloud2Arquivo(null);
      if (indice === 3) setLayoutCloud3Arquivo(null);

      await carregarLayout();
      alert(`Nuvem ${indice} removida com sucesso`);
    } catch (error) {
      const mensagem =
        error.response?.data?.message ||
        `Erro ao remover a nuvem ${indice} do login`;
      alert(mensagem);
    }
  }

  async function salvarLayout() {
    try {
      if (!Number(layoutCoinsPorNivel) || Number(layoutCoinsPorNivel) <= 0) {
        alert("Informe uma quantidade válida de moedas por nível");
        return;
      }

      setSalvandoLayout(true);

      await api.put("/layout", {
        app_name: layoutNome,
        primary_color: layoutCorPrimaria,
        secondary_color: layoutCorSecundaria,
        accent_color: layoutCorDestaque,
        font_family: layoutFonte,
        show_clouds: layoutMostrarNuvens,
        coins_per_level: Number(layoutCoinsPorNivel) || 500,
        level_names: layoutNomesNiveis.map((item) => item.trim() || "Nível"),
      });

      if (layoutLogoArquivo) {
        const formData = new FormData();
        formData.append("logo", layoutLogoArquivo);

        await api.post("/layout/logo", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }

      if (layoutCoinLogoArquivo) {
        const formData = new FormData();
        formData.append("coin_logo", layoutCoinLogoArquivo);

        await api.post("/layout/coin-logo", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }

      if (layoutLoginBackgroundArquivo) {
        const formData = new FormData();
        formData.append("login_background", layoutLoginBackgroundArquivo);

        await api.post("/layout/login-background", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }

      if (layoutCloud1Arquivo) {
        const formData = new FormData();
        formData.append("login_cloud", layoutCloud1Arquivo);

        await api.post("/layout/login-cloud/1", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }

      if (layoutCloud2Arquivo) {
        const formData = new FormData();
        formData.append("login_cloud", layoutCloud2Arquivo);

        await api.post("/layout/login-cloud/2", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }

      if (layoutCloud3Arquivo) {
        const formData = new FormData();
        formData.append("login_cloud", layoutCloud3Arquivo);

        await api.post("/layout/login-cloud/3", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }

      setLayoutLogoArquivo(null);
      setLayoutCoinLogoArquivo(null);
      setLayoutLoginBackgroundArquivo(null);
      setLayoutCloud1Arquivo(null);
      setLayoutCloud2Arquivo(null);
      setLayoutCloud3Arquivo(null);

      await carregarLayout();
      alert("Layout atualizado com sucesso");
    } catch (error) {
      const mensagem = error.response?.data?.message || "Erro ao salvar layout";
      alert(mensagem);
    } finally {
      setSalvandoLayout(false);
    }
  }

  async function importarUsuariosPorArquivo() {
    if (!arquivoImportacao) {
      alert("Selecione um arquivo para importar");
      return;
    }

    try {
      setImportandoUsuarios(true);
      setResultadoImportacao(null);

      const formData = new FormData();
      formData.append("arquivo", arquivoImportacao);

      const response = await api.post("/admin/users/importar", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setResultadoImportacao(response.data);
      setArquivoImportacao(null);
      await carregarUsuarios();
      await carregarRankingsAdmin();
      setMostrarUsuarios(true);
    } catch (error) {
      const mensagem =
        error.response?.data?.message || "Erro ao importar usuários";
      alert(mensagem);
    } finally {
      setImportandoUsuarios(false);
    }
  }

  async function carregarQRCodes() {
    try {
      setCarregandoQRCodes(true);

      const response = await api.get("/admin/qrcodes");
      setQrcodes(response.data);
    } catch (error) {
      console.error("Erro ao carregar QR Codes:", error);
    } finally {
      setCarregandoQRCodes(false);
    }
  }

  async function carregarMensagensAdmin() {
    try {
      const response = await api.get("/admin/messages");
      setMensagensAdmin(response.data);
    } catch (error) {
      console.error("Erro ao carregar mensagens admin:", error);
    }
  }

  async function enviarMensagemAdmin() {
    if (!tituloMensagem.trim() || !conteudoMensagem.trim()) {
      alert("Informe título e conteúdo da mensagem");
      return;
    }

    try {
      setEnviandoMensagem(true);

      await api.post("/admin/messages", {
        titulo: tituloMensagem.trim(),
        conteudo: conteudoMensagem.trim(),
        grupos_destino: gruposDestinoMensagem,
        exige_confirmacao: exigeConfirmacaoMensagem,
      });

      setTituloMensagem("");
      setConteudoMensagem("");
      setGruposDestinoMensagem(["todos"]);
      setExigeConfirmacaoMensagem(false);

      await carregarMensagensAdmin();
      alert("Mensagem enviada com sucesso");
    } catch (error) {
      const mensagem =
        error.response?.data?.message || "Erro ao enviar mensagem";
      alert(mensagem);
    } finally {
      setEnviandoMensagem(false);
    }
  }

  async function excluirMensagemAdmin(id) {
    const confirmar = window.confirm("Deseja excluir esta mensagem?");
    if (!confirmar) return;

    try {
      await api.delete(`/admin/messages/${id}`);
      await carregarMensagensAdmin();
    } catch (error) {
      const mensagem =
        error.response?.data?.message || "Erro ao excluir mensagem";
      alert(mensagem);
    }
  }

  async function limparMensagensAdmin() {
    if (mensagensAdmin.length === 0) {
      alert("Não há mensagens para limpar");
      return;
    }

    const confirmar = window.confirm(
      "Deseja excluir todas as mensagens do admin?",
    );
    if (!confirmar) return;

    try {
      await api.delete("/admin/messages");
      await carregarMensagensAdmin();
    } catch (error) {
      const mensagem =
        error.response?.data?.message || "Erro ao limpar mensagens";
      alert(mensagem);
    }
  }

  async function resetarSaldoDeTodos() {
    const confirmar = window.confirm(
      "Tem certeza que deseja resetar o saldo de todos os usuários? Essa ação irá zerar os saldos.",
    );

    if (!confirmar) return;

    try {
      setProcessandoResetSaldo(true);

      const response = await api.post("/admin/users/reset-saldos");

      await carregarUsuarios();
      await carregarRankingsAdmin();

      alert(
        response.data?.message ||
          "Saldo de todos os usuários resetado com sucesso",
      );
    } catch (error) {
      const mensagem =
        error.response?.data?.message ||
        "Erro ao resetar saldo de todos os usuários";
      alert(mensagem);
    } finally {
      setProcessandoResetSaldo(false);
    }
  }

  async function apagarExtratoDeTodos() {
    const confirmar = window.confirm(
      "Tem certeza que deseja apagar todo o extrato de todos os usuários? Essa ação não poderá ser desfeita.",
    );

    if (!confirmar) return;

    try {
      setProcessandoResetExtrato(true);

      const response = await api.delete("/admin/users/reset-extrato");

      alert(
        response.data?.message ||
          "Extrato de todos os usuários apagado com sucesso",
      );
    } catch (error) {
      const mensagem =
        error.response?.data?.message ||
        "Erro ao apagar o extrato de todos os usuários";
      alert(mensagem);
    } finally {
      setProcessandoResetExtrato(false);
    }
  }

  async function resetGeralDoSistema() {
    const aviso = window.confirm(
      "ATENÇÃO: o reset geral irá apagar todos os usuários comuns, extrato, QR Codes e mensagens do admin. Apenas o layout e o usuário admin@teleios.com serão mantidos. Deseja continuar?",
    );

    if (!aviso) return;

    const confirmacao = window.prompt(
      'Para confirmar o reset geral, digite exatamente a palavra "excluir".',
    );

    if (confirmacao === null) return;

    if (String(confirmacao).trim().toLowerCase() !== "excluir") {
      alert("Confirmação inválida. O reset geral foi cancelado.");
      return;
    }

    try {
      setProcessandoResetGeral(true);

      const response = await api.post("/admin/reset-geral", {
        confirmacao: "excluir",
      });

      await carregarUsuarios();
      await carregarQRCodes();
      await carregarMensagensAdmin();
      await carregarRankingsAdmin();

      setBuscaUsuario("");
      cancelarEdicao();
      limparFormularioCriacao();
      limparFormularioQRCode();

      alert(response.data?.message || "Reset geral realizado com sucesso");
    } catch (error) {
      const mensagem =
        error.response?.data?.message || "Erro ao executar o reset geral";
      alert(mensagem);
    } finally {
      setProcessandoResetGeral(false);
    }
  }

  const usuariosFiltrados = useMemo(() => {
    const termo = buscaUsuario.trim().toLowerCase();

    if (!termo) return users;

    return users.filter((user) => {
      const nome = user.nome?.toLowerCase() || "";
      const email = user.email?.toLowerCase() || "";
      const celular = user.celular?.toLowerCase() || "";

      return (
        nome.includes(termo) ||
        email.includes(termo) ||
        celular.includes(termo)
      );
    });
  }, [users, buscaUsuario]);

  function limparFormularioCriacao() {
    setNovoNome("");
    setNovoDataNascimento("");
    setNovoSexo("");
    setNovoIdade("");
    setNovoCelular("");
    setNovoEmail("");
    setNovoSaldo("");
    setNovaSenha("");
    setNovoIsLider(false);
    setMostrarSenha(false);
  }

  function limparFormularioQRCode() {
    setQrNome("");
    setQrValor("");
    setQrDataInicio("");
    setQrHoraInicio("");
    setQrDataFim("");
    setQrHoraFim("");
    setQrRaio("100");
    setQrLocais([]);
  }

  function iniciarEdicao(user) {
    setUsuarioEmEdicao(user._id);
    setEditNome(user.nome || "");
    setEditDataNascimento(converterIsoParaDataBR(user.data_nascimento || ""));
    setEditSexo(user.sexo || "");
    setEditIdade(user.idade || "");
    setEditCelular(user.celular || "");
    setEditEmail(user.email || "");
    setEditSenha("");
    setEditIsLider(!!user.is_lider);
    setMostrarSenhaEdicao(false);
    setMostrarUsuarios(true);
  }

  function cancelarEdicao() {
    setUsuarioEmEdicao(null);
    setEditNome("");
    setEditDataNascimento("");
    setEditSexo("");
    setEditIdade("");
    setEditCelular("");
    setEditEmail("");
    setEditSenha("");
    setEditIsLider(false);
    setMostrarSenhaEdicao(false);
  }

  async function criarUsuario() {
    if (!novoNome.trim()) {
      alert("Informe o nome do usuário");
      return;
    }

    if (!novoDataNascimento.trim()) {
      alert("Informe a data de nascimento");
      return;
    }

    if (!validarDataBR(novoDataNascimento)) {
      alert("Informe uma data de nascimento válida no formato DD/MM/AAAA");
      return;
    }

    if (!novoEmail.trim()) {
      alert("Informe o e-mail do usuário");
      return;
    }

    if (!novaSenha.trim()) {
      alert("Informe uma senha");
      return;
    }

    if (Number(novoSaldo) < 0) {
      alert("Saldo não pode ser negativo");
      return;
    }

    try {
      setSalvando(true);
      setErro("");

      await api.post("/admin/users", {
        nome: novoNome.trim(),
        data_nascimento: converterDataBRParaISO(novoDataNascimento),
        sexo: novoSexo || "",
        idade: Number(novoIdade) || 0,
        celular: novoCelular.trim(),
        email: novoEmail.trim(),
        senha: novaSenha,
        saldo: Number(novoSaldo) || 0,
        is_lider: novoIsLider,
      });

      limparFormularioCriacao();
      await carregarUsuarios();
      await carregarRankingsAdmin();
      setMostrarUsuarios(true);
    } catch (error) {
      const mensagem = error.response?.data?.message || "Erro ao criar usuário";
      setErro(mensagem);
    } finally {
      setSalvando(false);
    }
  }

  async function salvarEdicao() {
    if (!editNome.trim()) {
      alert("Informe o nome do usuário");
      return;
    }

    if (!editDataNascimento.trim()) {
      alert("Informe a data de nascimento");
      return;
    }

    if (!validarDataBR(editDataNascimento)) {
      alert("Informe uma data de nascimento válida no formato DD/MM/AAAA");
      return;
    }

    if (!editEmail.trim()) {
      alert("Informe o e-mail do usuário");
      return;
    }

    try {
      setSalvando(true);
      setErro("");

      const payload = {
        nome: editNome.trim(),
        data_nascimento: converterDataBRParaISO(editDataNascimento),
        sexo: editSexo || "",
        idade: Number(editIdade) || 0,
        celular: editCelular.trim(),
        email: editEmail.trim(),
        is_lider: editIsLider,
      };

      if (editSenha.trim()) {
        payload.senha = editSenha.trim();
      }

      await api.put(`/admin/users/${usuarioEmEdicao}`, payload);

      cancelarEdicao();
      await carregarUsuarios();
      await carregarRankingsAdmin();
    } catch (error) {
      const mensagem =
        error.response?.data?.message || "Erro ao editar usuário";
      setErro(mensagem);
    } finally {
      setSalvando(false);
    }
  }

  async function excluirUsuario(id) {
    const confirmar = window.confirm("Deseja realmente excluir este usuário?");
    if (!confirmar) return;

    try {
      setErro("");
      await api.delete(`/admin/users/${id}`);

      if (usuarioEmEdicao === id) {
        cancelarEdicao();
      }

      await carregarUsuarios();
      await carregarRankingsAdmin();
    } catch (error) {
      const mensagem =
        error.response?.data?.message || "Erro ao excluir usuário";
      setErro(mensagem);
    }
  }

  async function alterarSaldo(id, tipo) {
    const valorDigitado = window.prompt(
      `Informe o valor para ${tipo === "entrada" ? "adicionar" : "remover"}`,
    );

    if (!valorDigitado) return;

    const valor = Number(valorDigitado);

    if (Number.isNaN(valor) || valor <= 0) {
      alert("Informe um valor válido maior que zero");
      return;
    }

    const descricao =
      tipo === "entrada"
        ? "Depósito manual do administrador"
        : "Ajuste manual do administrador";

    try {
      setErro("");

      await api.patch(`/admin/users/${id}/saldo`, {
        tipo,
        valor,
        descricao,
      });

      await carregarUsuarios();
      await carregarRankingsAdmin();
    } catch (error) {
      const mensagem = error.response?.data?.message || "Erro ao alterar saldo";
      setErro(mensagem);
    }
  }

  function adicionarLocal(local) {
    setQrLocais((prev) => [...prev, local]);
    setMostrarMapa(false);
  }

  function removerLocal(index) {
    setQrLocais((prev) => prev.filter((_, i) => i !== index));
  }

  async function criarQRCode() {
    if (!qrNome.trim()) {
      alert("Informe o nome da campanha");
      return;
    }

    if (!qrValor || Number(qrValor) <= 0) {
      alert("Informe um valor válido");
      return;
    }

    if (!qrDataInicio || !qrHoraInicio || !qrDataFim || !qrHoraFim) {
      alert("Informe a data e hora de início e fim");
      return;
    }

    if (!validarDataBR(qrDataInicio) || !validarHora(qrHoraInicio)) {
      alert("Informe uma data e hora de início válidas");
      return;
    }

    if (!validarDataBR(qrDataFim) || !validarHora(qrHoraFim)) {
      alert("Informe uma data e hora de fim válidas");
      return;
    }

    const inicioISO = montarDataHoraISO(qrDataInicio, qrHoraInicio);
    const fimISO = montarDataHoraISO(qrDataFim, qrHoraFim);

    if (!inicioISO || !fimISO) {
      alert("Não foi possível montar as datas do QR Code");
      return;
    }

    if (new Date(inicioISO) >= new Date(fimISO)) {
      alert("A data/hora final deve ser maior que a data/hora inicial");
      return;
    }

    if (qrLocais.length > 0 && (!qrRaio || Number(qrRaio) <= 0)) {
      alert("Informe um raio válido");
      return;
    }

    try {
      setSalvandoQRCode(true);

      const locaisPayload = qrLocais.map((local, index) => ({
        nome: `Local ${index + 1}`,
        endereco: local.endereco,
        latitude: Number(local.latitude),
        longitude: Number(local.longitude),
        raio_metros: Number(qrRaio),
      }));

      await api.post("/admin/qrcodes", {
        nome: qrNome.trim(),
        valor: Number(qrValor),
        inicio: inicioISO,
        fim: fimISO,
        locais_permitidos: locaisPayload,
        tipo_operacao: tipoOperacaoQRCode,
      });

      limparFormularioQRCode();
      await carregarQRCodes();
      alert("QR Code criado com sucesso");
    } catch (error) {
      const mensagem = error.response?.data?.message || "Erro ao criar QR Code";
      alert(mensagem);
    } finally {
      setSalvandoQRCode(false);
    }
  }

  async function excluirQRCode(id) {
    const confirmar = window.confirm("Deseja realmente excluir este QR Code?");
    if (!confirmar) return;

    try {
      await api.delete(`/admin/qrcodes/${id}`);
      await carregarQRCodes();
    } catch (error) {
      const mensagem =
        error.response?.data?.message || "Erro ao excluir QR Code";
      alert(mensagem);
    }
  }

  function baixarQRCode(base64, nome) {
    const link = document.createElement("a");
    link.href = base64;
    link.download = `${nome || "qrcode"}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  function handleLogout() {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
  }

  function menuVisivel(texto) {
    const termo = buscaMenuAdmin.trim().toLowerCase();
    if (!termo) return true;

    return texto.toLowerCase().includes(termo);
  }

  return (
    <div className="dashboard app-theme-bg">
      <div className="dashboard-wrapper page-shell">
        <div className="header">
          <span className="user-name">Admin Dashboard</span>

          <button className="logout-btn" onClick={handleLogout}>
            Sair
          </button>
        </div>

        <div className="admin-dashboard-search-wrap">
          <div className="admin-dashboard-search-box">
            <span className="admin-dashboard-search-icon">🔎</span>
            <input
              className="admin-dashboard-search-input"
              placeholder="Pesquisar menu do admin"
              value={buscaMenuAdmin}
              onChange={(e) => setBuscaMenuAdmin(e.target.value)}
            />
          </div>
        </div>

        <div className="admin-sections-shell admin-sections-shell-modern">
          <SectionCard
            title="Criar usuário manualmente"
            subtitle="Cadastro individual de usuário"
            icon="👤"
            open={mostrarCriacaoManual}
            onToggle={() => setMostrarCriacaoManual(!mostrarCriacaoManual)}
            hidden={
              !menuVisivel(
                "criar usuário manualmente cadastro individual usuário",
              )
            }
          >
            <div className="actions">
              <input
                className="input"
                placeholder="Nome"
                value={novoNome}
                onChange={(e) => setNovoNome(e.target.value)}
              />

              <input
                className="input"
                type="text"
                inputMode="numeric"
                maxLength={10}
                placeholder="Data de nascimento (DD/MM/AAAA)"
                value={novoDataNascimento}
                onChange={(e) => {
                  const data = aplicarMascaraData(e.target.value);
                  setNovoDataNascimento(data);
                  setNovoIdade(calcularIdade(data));
                }}
              />

              <select
                className="input"
                value={novoSexo}
                onChange={(e) => setNovoSexo(e.target.value)}
              >
                <option value="">Selecione o sexo</option>
                <option value="Masculino">Masculino</option>
                <option value="Feminino">Feminino</option>
                <option value="Outro">Outro</option>
              </select>

              <input
                className="input"
                placeholder="Idade calculada automaticamente"
                type="number"
                value={novoIdade}
                disabled
              />

              <input
                className="input"
                placeholder="Celular"
                value={novoCelular}
                onChange={(e) => setNovoCelular(e.target.value)}
              />

              <input
                className="input"
                placeholder="E-mail"
                value={novoEmail}
                onChange={(e) => setNovoEmail(e.target.value)}
              />

              <input
                className="input"
                placeholder="Saldo inicial"
                type="number"
                value={novoSaldo}
                onChange={(e) => setNovoSaldo(e.target.value)}
              />

              <div className="input-wrapper">
                <input
                  className="input"
                  placeholder="Senha"
                  type={mostrarSenha ? "text" : "password"}
                  value={novaSenha}
                  onChange={(e) => setNovaSenha(e.target.value)}
                />

                <button
                  type="button"
                  className="toggle-password"
                  onClick={() => setMostrarSenha((prev) => !prev)}
                  aria-label={mostrarSenha ? "Ocultar senha" : "Mostrar senha"}
                >
                  <img
                    src={mostrarSenha ? olhoFechado : olhoAberto}
                    alt={mostrarSenha ? "Ocultar senha" : "Mostrar senha"}
                    className="icone-olho"
                  />
                </button>
              </div>

              <label
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  color: "#fff",
                }}
              >
                <input
                  type="checkbox"
                  checked={novoIsLider}
                  onChange={(e) => setNovoIsLider(e.target.checked)}
                />
                Usuário é líder
              </label>

              <button
                className="action-btn"
                onClick={criarUsuario}
                disabled={salvando}
              >
                {salvando ? "Criando..." : "Criar"}
              </button>
            </div>

            {erro && (
              <p style={{ color: "#ff6b6b", marginTop: "12px" }}>{erro}</p>
            )}
          </SectionCard>

          <SectionCard
            title="Criar usuários por carga"
            subtitle="Importação em lote por arquivo"
            icon="📥"
            open={mostrarImportacao}
            onToggle={() => setMostrarImportacao(!mostrarImportacao)}
            hidden={
              !menuVisivel(
                "criar usuários por carga importação lote arquivo csv excel",
              )
            }
          >
            <div className="actions">
              <button
                type="button"
                className="action-btn secondary"
                onClick={baixarModeloUsuarios}
              >
                Baixar modelo
              </button>

              <input
                className="input"
                type="file"
                accept=".csv,.xlsx,.xls"
                onChange={(e) =>
                  setArquivoImportacao(e.target.files?.[0] || null)
                }
              />

              <button
                type="button"
                className="action-btn"
                onClick={importarUsuariosPorArquivo}
                disabled={importandoUsuarios}
              >
                {importandoUsuarios ? "Importando..." : "Importar usuários"}
              </button>
            </div>

            <p style={{ color: "#9fb3c8", marginTop: 10, fontSize: 14 }}>
              Use o modelo padrão com as colunas: nome, data_nascimento, email,
              celular, sexo, senha, saldo_inicial, Lider.
            </p>

            {resultadoImportacao && (
              <div style={{ marginTop: 16 }}>
                <p style={{ color: "#fff" }}>
                  <strong>Resultado da importação</strong>
                </p>

                <p style={{ color: "#9fb3c8" }}>
                  Total de linhas: {resultadoImportacao.total_linhas} |
                  Importados: {resultadoImportacao.importados} | Erros:{" "}
                  {resultadoImportacao.erros}
                </p>

                <div
                  style={{
                    maxHeight: 220,
                    overflowY: "auto",
                    marginTop: 10,
                    paddingRight: 6,
                  }}
                >
                  {resultadoImportacao.resultados?.map((item, index) => (
                    <div className="extrato-item" key={index}>
                      <div>
                        <strong>{item.motivo}</strong>
                      </div>

                      <button
                        type="button"
                        className="action-btn"
                        style={{
                          maxWidth: 90,
                          minWidth: 90,
                          padding: "10px 0",
                          flex: "none",
                        }}
                        onClick={() => setResultadoImportacao(null)}
                      >
                        OK
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </SectionCard>

          <SectionCard
            title="Usuários cadastrados"
            subtitle={
              loading
                ? "Carregando usuários..."
                : erroUsuarios
                  ? "Falha ao carregar usuários"
                  : `Total: ${users.length}`
            }
            icon="📋"
            open={mostrarUsuarios}
            onToggle={() => setMostrarUsuarios(!mostrarUsuarios)}
            hidden={
              !menuVisivel(
                "usuários cadastrados lista usuários editar saldo buscar",
              )
            }
          >
            <div style={{ marginTop: 0 }}>
              <input
                className="input"
                placeholder="Buscar por nome, e-mail ou celular"
                value={buscaUsuario}
                onChange={(e) => setBuscaUsuario(e.target.value)}
              />
            </div>

            <div
              style={{
                marginTop: 16,
                maxHeight: 520,
                overflowY: "auto",
                paddingRight: 6,
              }}
            >
              {loading ? (
                <p style={{ color: "#ccc" }}>Carregando usuários...</p>
              ) : erroUsuarios ? (
                <p style={{ color: "#ffb3b3" }}>{erroUsuarios}</p>
              ) : usuariosFiltrados.length === 0 ? (
                <p style={{ color: "#ccc" }}>
                  Nenhum usuário encontrado para essa busca.
                </p>
              ) : (
                usuariosFiltrados.map((user) => (
                  <div
                    className="extrato-item"
                    key={user._id}
                    style={{ flexDirection: "column", alignItems: "stretch" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: 12,
                        alignItems: "flex-start",
                        flexWrap: "wrap",
                      }}
                    >
                      <div>
                        <strong>{user.nome}</strong>
                        <div className="extrato-data">{user.email}</div>
                        <div className="extrato-data">
                          Celular: {user.celular || "-"}
                        </div>
                        <div className="extrato-data">
                          Sexo: {user.sexo || "-"} | Idade: {user.idade || 0}
                        </div>
                        <div className="extrato-data">
                          Nascimento: {formatarDataExibicao(user.data_nascimento)}
                        </div>
                        <div className="extrato-data">
                          Saldo:{" "}
                          {Number(user.saldo || 0).toLocaleString("pt-BR")}{" "}
                          Coins
                        </div>
                        <div className="extrato-data">
                          Líder: {user.is_lider ? "Sim" : "Não"}
                        </div>
                        <div className="extrato-data">Perfil: {user.role}</div>
                      </div>

                      <div
                        style={{ display: "flex", gap: 6, flexWrap: "wrap" }}
                      >
                        <button
                          className="action-btn"
                          onClick={() => alterarSaldo(user._id, "entrada")}
                        >
                          + saldo
                        </button>

                        <button
                          className="action-btn secondary"
                          onClick={() => alterarSaldo(user._id, "saida")}
                        >
                          - saldo
                        </button>

                        <button
                          className="action-btn secondary"
                          onClick={() => iniciarEdicao(user)}
                        >
                          Editar
                        </button>
                      </div>
                    </div>

                    {usuarioEmEdicao === user._id && (
                      <div style={{ marginTop: 16 }}>
                        <div className="actions">
                          <input
                            className="input"
                            placeholder="Nome"
                            value={editNome}
                            onChange={(e) => setEditNome(e.target.value)}
                          />

                          <input
                            className="input"
                            type="text"
                            inputMode="numeric"
                            maxLength={10}
                            placeholder="Data de nascimento (DD/MM/AAAA)"
                            value={editDataNascimento}
                            onChange={(e) => {
                              const data = aplicarMascaraData(e.target.value);
                              setEditDataNascimento(data);
                              setEditIdade(calcularIdade(data));
                            }}
                          />

                          <select
                            className="input"
                            value={editSexo}
                            onChange={(e) => setEditSexo(e.target.value)}
                          >
                            <option value="">Selecione o sexo</option>
                            <option value="Masculino">Masculino</option>
                            <option value="Feminino">Feminino</option>
                            <option value="Outro">Outro</option>
                          </select>

                          <input
                            className="input"
                            placeholder="Idade calculada automaticamente"
                            type="number"
                            value={editIdade}
                            disabled
                          />

                          <input
                            className="input"
                            placeholder="Celular"
                            value={editCelular}
                            onChange={(e) => setEditCelular(e.target.value)}
                          />

                          <input
                            className="input"
                            placeholder="E-mail"
                            value={editEmail}
                            onChange={(e) => setEditEmail(e.target.value)}
                          />

                          <div className="input-wrapper">
                            <input
                              className="input"
                              placeholder="Nova senha (opcional)"
                              type={mostrarSenhaEdicao ? "text" : "password"}
                              value={editSenha}
                              onChange={(e) => setEditSenha(e.target.value)}
                            />

                            <button
                              type="button"
                              className="toggle-password"
                              onClick={() =>
                                setMostrarSenhaEdicao((prev) => !prev)
                              }
                              aria-label={
                                mostrarSenhaEdicao
                                  ? "Ocultar senha"
                                  : "Mostrar senha"
                              }
                            >
                              <img
                                src={
                                  mostrarSenhaEdicao
                                    ? olhoFechado
                                    : olhoAberto
                                }
                                alt={
                                  mostrarSenhaEdicao
                                    ? "Ocultar senha"
                                    : "Mostrar senha"
                                }
                                className="icone-olho"
                              />
                            </button>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              gap: 8,
                              flexWrap: "wrap",
                            }}
                          >
                            <label
                              style={{
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                                gap: 10,
                                color: "#fff",
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={editIsLider}
                                onChange={(e) => setEditIsLider(e.target.checked)}
                              />
                              Usuário é líder
                            </label>

                            <button
                              className="action-btn"
                              onClick={salvarEdicao}
                              disabled={salvando}
                            >
                              {salvando ? "Salvando..." : "Salvar"}
                            </button>

                            <button
                              className="action-btn secondary"
                              onClick={cancelarEdicao}
                              disabled={salvando}
                            >
                              Cancelar
                            </button>

                            <button
                              className="action-btn secondary"
                              onClick={() => excluirUsuario(user._id)}
                              disabled={salvando}
                            >
                              Excluir usuário
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ))
              )}
            </div>
          </SectionCard>

          <SectionCard
            title="Mensagens do admin"
            subtitle="Envio de avisos para grupos"
            icon="💬"
            open={mostrarMensagensAdmin}
            onToggle={() => setMostrarMensagensAdmin(!mostrarMensagensAdmin)}
            hidden={
              !menuVisivel("mensagens admin avisos grupos next ge lideres")
            }
          >
            <div className="actions">
              <input
                className="input"
                placeholder="Título da mensagem"
                value={tituloMensagem}
                onChange={(e) => setTituloMensagem(e.target.value)}
              />

              <textarea
                className="input"
                placeholder="Escreva a mensagem"
                value={conteudoMensagem}
                onChange={(e) => setConteudoMensagem(e.target.value)}
                rows={5}
                style={{ resize: "vertical" }}
              />

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: 8,
                  color: "#fff",
                }}
              >
                <strong>Enviar para:</strong>
              
                {[
                  { value: "todos", label: "Todos os grupos" },
                  { value: "next", label: "Grupo Next" },
                  { value: "ge", label: "Grupo GE" },
                  { value: "lideres", label: "Grupo Líderes" },
                ].map((grupo) => (
                  <label
                    key={grupo.value}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={gruposDestinoMensagem.includes(grupo.value)}
                      onChange={() => alternarGrupoDestinoMensagem(grupo.value)}
                    />
                    {grupo.label}
                  </label>
                ))}
              </div>
              
              <label
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  color: "#fff",
                  marginTop: 4,
                }}
              >
                <input
                  type="checkbox"
                  checked={exigeConfirmacaoMensagem}
                  onChange={(e) => setExigeConfirmacaoMensagem(e.target.checked)}
                />
                Exigir confirmação de leitura
              </label>
              
              <button
                className="action-btn"
                onClick={enviarMensagemAdmin}
                disabled={enviandoMensagem}
              >
                {enviandoMensagem ? "Enviando..." : "Enviar mensagem"}
              </button>

              <button
                type="button"
                className="action-btn secondary"
                onClick={limparMensagensAdmin}
              >
                Limpar mensagens
              </button>
            </div>

            <div style={{ marginTop: 20 }}>
              <h4 style={{ color: "#fff", marginBottom: 10 }}>
                Mensagens enviadas
              </h4>

              {mensagensAdmin.length === 0 ? (
                <p style={{ color: "#ccc" }}>Nenhuma mensagem enviada ainda.</p>
              ) : (
                mensagensAdmin.map((msg) => (
                  <div
                    className="extrato-item"
                    key={msg._id}
                    style={{ flexDirection: "column", alignItems: "stretch" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: 12,
                        flexWrap: "wrap",
                        alignItems: "flex-start",
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <strong>{msg.titulo}</strong>
                        <div className="extrato-data">
                          {new Date(msg.createdAt).toLocaleString("pt-BR")}
                        </div>
                        <div style={{ marginTop: 8, color: "#dfe8ef" }}>
                          {msg.conteudo}
                        </div>
                        <div className="extrato-data" style={{ marginTop: 8 }}>
                          {formatarGrupoMensagem(msg.grupos_destino || msg.grupo_destino)}
                        </div>
                        {msg.exige_confirmacao && (
                          <>
                            <div style={{ color: "#ffdd99", fontSize: 13, marginTop: 8 }}>
                              Exige confirmação de leitura
                            </div>
                        
                            <button
                              type="button"
                              className="action-btn secondary"
                              style={{ marginTop: 10 }}
                              onClick={() => toggleMensagemExpandida(msg._id)}
                            >
                              {mensagensExpandidas[msg._id]
                                ? "Ocultar confirmações"
                                : "Ver confirmações"}
                            </button>
                        
                            {mensagensExpandidas[msg._id] && (
                              <div
                                style={{
                                  marginTop: 12,
                                  padding: 12,
                                  borderRadius: 10,
                                  background: "rgba(255,255,255,0.05)",
                                }}
                              >
                                {!msg.confirmacoes_leitura ||
                                msg.confirmacoes_leitura.length === 0 ? (
                                  <div style={{ color: "#ccc" }}>
                                    Nenhuma confirmação ainda.
                                  </div>
                                ) : (
                                  msg.confirmacoes_leitura.map((confirmacao, index) => (
                                    <div
                                      key={index}
                                      style={{
                                        marginBottom: 10,
                                        paddingBottom: 10,
                                        borderBottom: "1px solid rgba(255,255,255,0.08)",
                                      }}
                                    >
                                      <div style={{ color: "#fff", fontWeight: "bold" }}>
                                        {confirmacao.user_id?.nome || "Usuário"}
                                      </div>
                        
                                      <div style={{ color: "#bbb", fontSize: 13 }}>
                                        {confirmacao.user_id?.email || ""}
                                      </div>
                        
                                      <div style={{ color: "#00e676", fontSize: 13, marginTop: 4 }}>
                                        Confirmado em{" "}
                                        {new Date(
                                          confirmacao.confirmado_em,
                                        ).toLocaleString("pt-BR")}
                                      </div>
                                    </div>
                                  ))
                                )}
                              </div>
                            )}
                          </>
                        )}
                      </div>

                      <button
                        className="action-btn secondary"
                        onClick={() => excluirMensagemAdmin(msg._id)}
                      >
                        Excluir
                      </button>
                    </div>
                  </div>
                ))
              )}
            </div>
          </SectionCard>

          <SectionCard
            title="Personalização do layout"
            subtitle="Tema visual da aplicação"
            icon="🎨"
            open={mostrarLayout}
            onToggle={() => setMostrarLayout(!mostrarLayout)}
            hidden={
              !menuVisivel(
                "personalização layout tema visual cores fonte logo login moeda",
              )
            }
          >
            <div className="actions">
              <div className="color-field">
                <label className="color-label">Cor principal</label>
                <div className="color-input-wrap">
                  <input
                    type="color"
                    value={layoutCorPrimaria}
                    onChange={(e) => setLayoutCorPrimaria(e.target.value)}
                  />
                  <span>{layoutCorPrimaria}</span>
                </div>
              </div>

              <div className="color-field">
                <label className="color-label">Cor secundária</label>
                <div className="color-input-wrap">
                  <input
                    type="color"
                    value={layoutCorSecundaria}
                    onChange={(e) => setLayoutCorSecundaria(e.target.value)}
                  />
                  <span>{layoutCorSecundaria}</span>
                </div>
              </div>

              <div className="color-field">
                <label className="color-label">Cor de destaque</label>
                <div className="color-input-wrap">
                  <input
                    type="color"
                    value={layoutCorDestaque}
                    onChange={(e) => setLayoutCorDestaque(e.target.value)}
                  />
                  <span>{layoutCorDestaque}</span>
                </div>
              </div>

              <div style={{ width: "100%" }}>
                <label className="color-label">Fonte</label>
                <select
                  className="input"
                  value={layoutFonte}
                  onChange={(e) => setLayoutFonte(e.target.value)}
                >
                  {fontesPermitidas.map((fonte) => (
                    <option key={fonte} value={fonte}>
                      {fonte}
                    </option>
                  ))}
                </select>
              </div>

              <div style={{ width: "100%" }}>
                <label className="color-label">Moedas por nível</label>
                <input
                  className="input"
                  type="number"
                  min="1"
                  placeholder="Quantidade de moedas por nível"
                  value={layoutCoinsPorNivel}
                  onChange={(e) => setLayoutCoinsPorNivel(e.target.value)}
                />
              </div>
              
              <div style={{ width: "100%" }}>
                <button
                  type="button"
                  className="action-btn secondary"
                  onClick={() => setMostrarEditarNiveis((prev) => !prev)}
                >
                  {mostrarEditarNiveis ? "Ocultar níveis" : "Editar nomes dos níveis"}
                </button>
              </div>
              
              {mostrarEditarNiveis && (
                <div
                  style={{
                    width: "100%",
                    padding: 14,
                    borderRadius: 14,
                    background: "rgba(255, 255, 255, 0.04)",
                    border: "1px solid rgba(255, 255, 255, 0.08)",
                  }}
                >
                  <div style={{ marginBottom: 12, color: "#dbe7f1", fontWeight: 700 }}>
                    Editar nomes dos níveis
                  </div>
              
                  {layoutNomesNiveis.map((nivel, index) => (
                    <div key={index} style={{ width: "100%" }}>
                      <label className="color-label">Nível {index + 1}</label>
                      <input
                        className="input"
                        type="text"
                        placeholder={`Nome do nível ${index + 1}`}
                        value={nivel}
                        onChange={(e) => atualizarNomeNivel(index, e.target.value)}
                      />
                    </div>
                  ))}
                </div>
              )}

              <div style={{ width: "100%" }}>
                <label className="color-label">Logo da tela de login</label>
                <input
                  className="input"
                  type="file"
                  accept="image/png,image/jpeg,image/webp"
                  onChange={(e) =>
                    setLayoutLogoArquivo(e.target.files?.[0] || null)
                  }
                />
              </div>

              <div style={{ width: "100%" }}>
                <label className="color-label">Logo da moeda</label>
                <input
                  className="input"
                  type="file"
                  accept="image/png,image/jpeg,image/webp"
                  onChange={(e) =>
                    setLayoutCoinLogoArquivo(e.target.files?.[0] || null)
                  }
                />
              </div>

              <div style={{ width: "100%" }}>
                <label className="color-label">Imagem de fundo do login</label>
                <input
                  className="input"
                  type="file"
                  accept="image/png,image/jpeg,image/webp"
                  onChange={(e) =>
                    setLayoutLoginBackgroundArquivo(e.target.files?.[0] || null)
                  }
                />

                <div style={{ marginTop: 10 }}>
                  <button
                    type="button"
                    className="action-btn secondary"
                    onClick={removerImagemLogin}
                  >
                    Remover imagem do login
                  </button>
                </div>
              </div>

              <div style={{ width: "100%" }}>
                <label className="color-label">Nuvem 1 do login</label>
                <input
                  className="input"
                  type="file"
                  accept="image/png,image/jpeg,image/webp"
                  onChange={(e) =>
                    setLayoutCloud1Arquivo(e.target.files?.[0] || null)
                  }
                />

                <div style={{ marginTop: 10 }}>
                  <button
                    type="button"
                    className="action-btn secondary"
                    onClick={() => removerNuvemLogin(1)}
                  >
                    Remover nuvem 1
                  </button>
                </div>
              </div>

              <div style={{ width: "100%" }}>
                <label className="color-label">Nuvem 2 do login</label>
                <input
                  className="input"
                  type="file"
                  accept="image/png,image/jpeg,image/webp"
                  onChange={(e) =>
                    setLayoutCloud2Arquivo(e.target.files?.[0] || null)
                  }
                />

                <div style={{ marginTop: 10 }}>
                  <button
                    type="button"
                    className="action-btn secondary"
                    onClick={() => removerNuvemLogin(2)}
                  >
                    Remover nuvem 2
                  </button>
                </div>
              </div>

              <div style={{ width: "100%" }}>
                <label className="color-label">Nuvem 3 do login</label>
                <input
                  className="input"
                  type="file"
                  accept="image/png,image/jpeg,image/webp"
                  onChange={(e) =>
                    setLayoutCloud3Arquivo(e.target.files?.[0] || null)
                  }
                />

                <div style={{ marginTop: 10 }}>
                  <button
                    type="button"
                    className="action-btn secondary"
                    onClick={() => removerNuvemLogin(3)}
                  >
                    Remover nuvem 3
                  </button>
                </div>
              </div>

              <button
                className="action-btn"
                onClick={salvarLayout}
                disabled={salvandoLayout}
              >
                {salvandoLayout ? "Salvando..." : "Salvar layout"}
              </button>
            </div>
          </SectionCard>

          <SectionCard
            title="Reset administrativo"
            subtitle="Ações de limpeza e restauração do sistema"
            icon="⚠️"
            open={mostrarResetAdmin}
            onToggle={() => setMostrarResetAdmin(!mostrarResetAdmin)}
            hidden={
              !menuVisivel(
                "reset administrativo limpar restaurar sistema saldo extrato reset geral",
              )
            }
          >
            <div className="actions">
              <button
                type="button"
                className="action-btn secondary"
                onClick={resetarSaldoDeTodos}
                disabled={processandoResetSaldo}
              >
                {processandoResetSaldo
                  ? "Resetando saldos..."
                  : "Resetar saldo de todos"}
              </button>

              <button
                type="button"
                className="action-btn secondary"
                onClick={apagarExtratoDeTodos}
                disabled={processandoResetExtrato}
              >
                {processandoResetExtrato
                  ? "Apagando extrato..."
                  : "Apagar extrato de todos"}
              </button>

              <button
                type="button"
                className="action-btn secondary"
                onClick={resetGeralDoSistema}
                disabled={processandoResetGeral}
                style={{
                  borderColor: "#ff6b6b",
                  color: "#ff6b6b",
                }}
              >
                {processandoResetGeral
                  ? "Executando reset geral..."
                  : "Reset geral do sistema"}
              </button>
            </div>

            <p style={{ color: "#ffb3b3", marginTop: 14, lineHeight: 1.6 }}>
              O reset geral apaga todos os usuários comuns, extrato, QR Codes e
              mensagens do admin. O layout é mantido e o usuário
              admin@teleios.com é preservado.
            </p>
          </SectionCard>

          <SectionCard
            title="Relatórios"
            subtitle="Exportação de arquivos CSV"
            icon="📊"
            open={mostrarRelatorios}
            onToggle={() => setMostrarRelatorios(!mostrarRelatorios)}
            hidden={
              !menuVisivel(
                "relatórios exportação csv usuários rankings extrato qrcodes",
              )
            }
          >
            <div className="actions">
              <button
                type="button"
                className="action-btn"
                onClick={baixarRelatorioUsuariosCSV}
              >
                Baixar relatório de usuários
              </button>

              <button
                type="button"
                className="action-btn"
                onClick={baixarRelatorioRankingsCSV}
              >
                Baixar relatório de rankings
              </button>

              <button
                type="button"
                className="action-btn"
                onClick={baixarRelatorioExtratoCSV}
              >
                Baixar relatório de extrato
              </button>

              <button
                type="button"
                className="action-btn"
                onClick={baixarRelatorioQRCodesCSV}
              >
                Baixar relatório de QR Codes
              </button>
            </div>

            <p style={{ color: "#9fb3c8", marginTop: 14, lineHeight: 1.6 }}>
              Os relatórios são gerados em formato CSV para download.
            </p>
          </SectionCard>

          <SectionCard
            title="Gerar QR Code"
            subtitle="Criar novas campanhas com QR"
            icon="📱"
            open={mostrarGerarQR}
            onToggle={() => setMostrarGerarQR(!mostrarGerarQR)}
            hidden={
              !menuVisivel("gerar qr code campanha localização locais resgate")
            }
          >
            <div className="actions">
              <input
                className="input"
                placeholder="Nome da campanha"
                value={qrNome}
                onChange={(e) => setQrNome(e.target.value)}
              />

              <input
                className="input"
                placeholder="Valor em coins"
                type="number"
                value={qrValor}
                onChange={(e) => setQrValor(e.target.value)}
              />

              <input
                className="input"
                type="text"
                inputMode="numeric"
                maxLength={10}
                placeholder="Data de início (DD/MM/AAAA)"
                value={qrDataInicio}
                onChange={(e) =>
                  setQrDataInicio(aplicarMascaraData(e.target.value))
                }
              />

              <input
                className="input"
                type="text"
                inputMode="numeric"
                maxLength={5}
                placeholder="Hora de início (HH:mm)"
                value={qrHoraInicio}
                onChange={(e) =>
                  setQrHoraInicio(aplicarMascaraHora(e.target.value))
                }
              />

              <input
                className="input"
                type="text"
                inputMode="numeric"
                maxLength={10}
                placeholder="Data de fim (DD/MM/AAAA)"
                value={qrDataFim}
                onChange={(e) =>
                  setQrDataFim(aplicarMascaraData(e.target.value))
                }
              />

              <input
                className="input"
                type="text"
                inputMode="numeric"
                maxLength={5}
                placeholder="Hora de fim (HH:mm)"
                value={qrHoraFim}
                onChange={(e) =>
                  setQrHoraFim(aplicarMascaraHora(e.target.value))
                }
              />

              <input
                className="input"
                placeholder="Raio em metros (opcional)"
                type="number"
                value={qrRaio}
                onChange={(e) => setQrRaio(e.target.value)}
              />

              <button
                type="button"
                className="action-btn secondary"
                onClick={() => setMostrarMapa(true)}
              >
                Adicionar local
              </button>

              <div
  style={{
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 8,
  }}
>
  <strong style={{ color: "#fff" }}>
    Tipo de operação
  </strong>

  <label
    style={{
      display: "flex",
      alignItems: "center",
      gap: 10,
      color: "#fff",
    }}
  >
    <input
      type="radio"
      name="tipoOperacaoQRCode"
      value="credito"
      checked={tipoOperacaoQRCode === "credito"}
      onChange={() => setTipoOperacaoQRCode("credito")}
    />
    Creditar Coins
  </label>

  <label
    style={{
      display: "flex",
      alignItems: "center",
      gap: 10,
      color: "#fff",
    }}
  >
    <input
      type="radio"
      name="tipoOperacaoQRCode"
      value="debito"
      checked={tipoOperacaoQRCode === "debito"}
      onChange={() => setTipoOperacaoQRCode("debito")}
    />
    Debitar Coins
  </label>
</div>

              <button
                className="action-btn"
                onClick={criarQRCode}
                disabled={salvandoQRCode}
              >
                {salvandoQRCode ? "Gerando..." : "Gerar QR Code"}
              </button>
            </div>

            {qrLocais.length > 0 ? (
              <div style={{ marginTop: 16 }}>
                <p style={{ color: "#fff", marginBottom: 10 }}>
                  Locais adicionados:
                </p>

                {qrLocais.map((local, index) => (
                  <div
                    className="extrato-item"
                    key={`${local.latitude}-${local.longitude}-${index}`}
                  >
                    <div>
                      <strong>Local {index + 1}</strong>
                      <div className="extrato-data">{local.endereco}</div>
                    </div>

                    <button
                      className="action-btn secondary"
                      onClick={() => removerLocal(index)}
                    >
                      Remover
                    </button>
                  </div>
                ))}
              </div>
            ) : (
              <p style={{ color: "#ccc", marginTop: 16 }}>
                Nenhum local adicionado. Se continuar assim, o QR ficará livre.
              </p>
            )}
          </SectionCard>

          <SectionCard
            title="QR Codes gerados"
            subtitle={`Total: ${qrcodes.length}`}
            icon="🧾"
            open={mostrarQRCodesGerados}
            onToggle={() => setMostrarQRCodesGerados(!mostrarQRCodesGerados)}
            hidden={!menuVisivel("qr codes gerados campanhas lista qrcode")}
          >
            {carregandoQRCodes ? (
              <p style={{ color: "#ccc" }}>Carregando QR Codes...</p>
            ) : qrcodes.length === 0 ? (
              <p style={{ color: "#ccc" }}>Nenhum QR Code gerado.</p>
            ) : (
              qrcodes.map((item) => (
                <div
                  className="extrato-item"
                  key={item._id}
                  style={{ flexDirection: "column", alignItems: "stretch" }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: 20,
                      flexWrap: "wrap",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <strong>{item.nome}</strong>
                      <div className="extrato-data">Código: {item.codigo}</div>
                      <div className="extrato-data">
                        Valor: {item.valor} coins
                      </div>

                      {item.locais_permitidos?.length > 0 ? (
                        <>
                          <div className="extrato-data">
                            Locais permitidos: {item.locais_permitidos.length}
                          </div>

                          {item.locais_permitidos.map((local, index) => (
                            <div className="extrato-data" key={index}>
                              {index + 1}. {local.endereco} | raio{" "}
                              {local.raio_metros} m
                            </div>
                          ))}
                        </>
                      ) : (
                        <div className="extrato-data">
                          QR livre, sem restrição de localização
                        </div>
                      )}

                      <div className="extrato-data">
                        Início: {new Date(item.inicio).toLocaleString("pt-BR")}
                      </div>
                      <div className="extrato-data">
                        Fim: {new Date(item.fim).toLocaleString("pt-BR")}
                      </div>
                    </div>

                    <div style={{ textAlign: "center" }}>
                      {item.qr_image_base64 && (
                        <>
                          <img
                            src={item.qr_image_base64}
                            alt={`QR ${item.nome}`}
                            style={{
                              width: 160,
                              height: 160,
                              borderRadius: 12,
                              background: "#fff",
                              padding: 8,
                            }}
                          />

                          <div style={{ marginTop: 10 }}>
                            <button
                              className="action-btn"
                              onClick={() =>
                                baixarQRCode(item.qr_image_base64, item.codigo)
                              }
                            >
                              Baixar imagem
                            </button>
                          </div>

                          <div style={{ marginTop: 10 }}>
                            <button
                              className="action-btn secondary"
                              onClick={() => excluirQRCode(item._id)}
                            >
                              Excluir QR Code
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              ))
            )}
          </SectionCard>

          <SectionCard
            title="Ranking Next"
            subtitle="Faixa etária de 11 a 13 anos"
            icon="🏅"
            open={mostrarRankingNext}
            onToggle={() => setMostrarRankingNext(!mostrarRankingNext)}
            hidden={!menuVisivel("ranking next 11 13 faixa etária")}
          >
            {carregandoRankingsAdmin ? (
              <p style={{ color: "#ccc" }}>Carregando ranking Next...</p>
            ) : erroRankingsAdmin ? (
              <p style={{ color: "#ffb3b3" }}>{erroRankingsAdmin}</p>
            ) : rankingNext.length === 0 ? (
              <p style={{ color: "#ccc" }}>
                Nenhum usuário encontrado no ranking Next.
              </p>
            ) : (
              rankingNext.map((item, index) => {
                const info = getRankingInfo(index);
                const nivelRanking = getNivelPorSaldo(item.saldo);

                return (
                  <div className={info.classe} key={item._id}>
                    <div className="ranking-esquerda">
                      <span className="ranking-medalha">{info.medalha}</span>

                      <div className="ranking-textos">
                        <strong>
                          {info.posicao} {formatarNomeRanking(item.nome)}
                        </strong>
                      </div>
                    </div>

                    <div className="ranking-direita">
                      <div className="ranking-nivel">{nivelRanking}</div>
                      <div className="ranking-saldo">
                        {Number(item.saldo || 0).toLocaleString("pt-BR")} Coins
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </SectionCard>

          <SectionCard
            title="Ranking GE"
            subtitle="Faixa etária de 14 a 17 anos"
            icon="🏅"
            open={mostrarRankingGE}
            onToggle={() => setMostrarRankingGE(!mostrarRankingGE)}
            hidden={!menuVisivel("ranking ge 14 17 faixa etária")}
          >
            {carregandoRankingsAdmin ? (
              <p style={{ color: "#ccc" }}>Carregando ranking GE...</p>
            ) : erroRankingsAdmin ? (
              <p style={{ color: "#ffb3b3" }}>{erroRankingsAdmin}</p>
            ) : rankingGE.length === 0 ? (
              <p style={{ color: "#ccc" }}>
                Nenhum usuário encontrado no ranking GE.
              </p>
            ) : (
              rankingGE.map((item, index) => {
                const info = getRankingInfo(index);
                const nivelRanking = getNivelPorSaldo(item.saldo);

                return (
                  <div className={info.classe} key={item._id}>
                    <div className="ranking-esquerda">
                      <span className="ranking-medalha">{info.medalha}</span>

                      <div className="ranking-textos">
                        <strong>
                          {info.posicao} {formatarNomeRanking(item.nome)}
                        </strong>
                      </div>
                    </div>

                    <div className="ranking-direita">
                      <div className="ranking-nivel">{nivelRanking}</div>
                      <div className="ranking-saldo">
                        {Number(item.saldo || 0).toLocaleString("pt-BR")} Coins
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </SectionCard>

          <SectionCard
            title="Ranking Líderes"
            subtitle="Grupo especial definido por marcação manual"
            icon="🏅"
            open={mostrarRankingLideres}
            onToggle={() => setMostrarRankingLideres(!mostrarRankingLideres)}
            hidden={!menuVisivel("ranking líderes lideres grupo especial liderança")}
          >
            {carregandoRankingsAdmin ? (
              <p style={{ color: "#ccc" }}>Carregando ranking de líderes...</p>
            ) : erroRankingsAdmin ? (
              <p style={{ color: "#ffb3b3" }}>{erroRankingsAdmin}</p>
            ) : rankingLideres.length === 0 ? (
              <p style={{ color: "#ccc" }}>
                Nenhum usuário encontrado no ranking de líderes.
              </p>
            ) : (
              rankingLideres.map((item, index) => {
                const info = getRankingInfo(index);
                const nivelRanking = getNivelPorSaldo(item.saldo);

                return (
                  <div className={info.classe} key={item._id}>
                    <div className="ranking-esquerda">
                      <span className="ranking-medalha">{info.medalha}</span>

                      <div className="ranking-textos">
                        <strong>
                          {info.posicao} {formatarNomeRanking(item.nome)}
                        </strong>
                      </div>
                    </div>

                    <div className="ranking-direita">
                      <div className="ranking-nivel">{nivelRanking}</div>
                      <div className="ranking-saldo">
                        {Number(item.saldo || 0).toLocaleString("pt-BR")} Coins
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </SectionCard>
        </div>

        <Footer />
      </div>

      {mostrarMapa && (
        <ModalMapa
          onClose={() => setMostrarMapa(false)}
          onConfirm={adicionarLocal}
        />
      )}
    </div>
  );
}

export default AdminDashboard;
